export default __webpack_public_path__ + "static/media/spanish.d7b75df4.png";